export default {
  namespace: 'user',
  state: {
    id: null,
    nickname: null,
    realname: null
  },
  actions: {
    login(state, { user }) {
      return user;
    },
    update(state, { nickname, realname }) {
      return {
        ...state,
        nickname: nickname || state.nickname,
        realname: realname || state.realname
      };
    }
  }
};
